import GeneralService from '../services/general.service';
import * as _ from 'lodash';

const initialState = {
  fieldLayouts: []
}

export const general = {
  namespaced: true,
  state: initialState,
  actions: {
    async loadFieldLayouts({ commit,dispatch }, payload) {
      let response = await GeneralService.getFieldLayouts();
      if(response && response.data){
        commit('loadfieldLayoutsSuccess', response.data)
      }
    },
  },
  getters: {
    fieldLayouts: state => state.fieldLayouts
  },
  mutations: {
    loadfieldLayoutsSuccess(state, fieldLayouts) {
      state.fieldLayouts = fieldLayouts;
    }
  },
};

export default general;
